export enum TokenTypeEnum {
  AUTH = 'AUTH',
  TWO_FACTOR_AUTH = 'TWO_FACTOR_AUTH'
}
